const isLocal = window.location.hostname === 'localhost' || 
                window.location.hostname === '127.0.0.1' || 
                window.location.hostname.endsWith('.local') ||
                window.location.hostname.startsWith('192.168.');

export const API_BASE_URL = isLocal 
    ? 'http://localhost:3000' 
    : (process.env.REACT_APP_API_BASE_URL || 'https://backend.mars.i3lab.group');

export const ASSETS_BASE_URL = process.env.REACT_APP_ASSETS_BASE_URL || 'https://xxlnrpasoxqytsqnghhy.supabase.co/storage/v1/object/public/assets';

/**
 * Utility to get the full URL for an asset.
 * If the path already starts with http/https, it returns it as is.
 * If the path starts with /audio/, it prepends the API_BASE_URL.
 * Otherwise, it prepends the ASSETS_BASE_URL.
 */
export const getAssetUrl = (path, dbType) => {
    if (!path) return '';
    if (path.startsWith('http')) return path;
    
    // Ensure path starts with a slash if it's relative
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;
    
    // If it's a backend-served audio file (stored in DB)
    if (normalizedPath.startsWith('/audio/')) {
        const queryParam = dbType ? `?dbType=${dbType}` : '';
        return `${API_BASE_URL}${normalizedPath}${queryParam}`;
    }
    
    // Specifically handle the case where paths were like /audios/... or /assets/videos/...
    // but the bucket structure in Supabase is assets/audios/... or assets/videos/...
    // The ASSETS_BASE_URL already points to the bucket root.
    return `${ASSETS_BASE_URL}${normalizedPath}`;
};
